import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Spinner } from "react-bootstrap";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { ApplicationState } from "../store";
import { useGetProjectsQuery } from "../store/api/kinesense";
import * as GeneralStore from "../store/general/General";
import { Notifications } from "../utilities/Notifications/Notifications";
import { TaskArea } from "../utilities/Tasks/TaskArea";
import { AddProjectModal } from "./organisation/components/projects/AddProjectModal";
import "./StatusBar.scss";

type ReactSelectOption = { value: string; label: string; mediaCount?: number; isNew?: boolean };
const NEW_PROJECT_OPTION_VALUE = "__new_project__";

function StatusBar() {
    const dispatch = useDispatch();
    const { general } = useSelector((state: ApplicationState) => state);
    const activeProjectId = general?.activeProjectId;

    const [isAddProjectModalVisible, setIsAddProjectModalVisible] = useState(false);

    const { data: projects, isSuccess, isFetching } = useGetProjectsQuery();
    const hasLoadedProjects = isSuccess && !isFetching;
    const hasLoaded = hasLoadedProjects;

    function handleOnSelectedProject(opt: ReactSelectOption | null) {
        if (!opt) {
            return;
        }

        if (opt.value === NEW_PROJECT_OPTION_VALUE) {
            setIsAddProjectModalVisible(true);
            return;
        }
        dispatch(GeneralStore.actionCreators.setActiveProject(opt.value));
    }

    function handleOnClickNotifications() {
        if (Notifications.hasNotifications() || Notifications.isShowingOldNotifications()) {
            Notifications.clearNotifications();
        } else {
            Notifications.showOldNotifications();
        }
    }

    // const [activeNotifications, setActiveNotifications] = useState<Notification[]>([]);
    // const setNotifications = (notifications: Notification[]) => {
    //     setActiveNotifications([...notifications]);
    // };
    // useEffect(() => {
    //     Notifications.register("statusbar", setNotifications);
    // }, []);

    const options: ReactSelectOption[] = (projects ?? []).map((p) => ({
        value: p.projectId,
        label: p.name,
        mediaCount: p.mediaCount,
    }));

    const optionsWithCreate = [
        ...options,
        {
            value: NEW_PROJECT_OPTION_VALUE,
            label: "Create new project",
            isNew: true,
        },
    ];
    const selectedOption = options.find((p) => p.value == activeProjectId);

    const formatLabel = (data: ReactSelectOption) => (
        <div>
            <div className="fw-bold">{data.label}</div>
            {!data.isNew && <div className="second-line fst-italic">{data.mediaCount} Videos</div>}
        </div>
    );

    return (
        <footer className="status-bar">
            <div className="status-bar-project">
                <span className="fst-italic lh-sm">Active project:</span>
                <Select
                    isLoading={!hasLoaded}
                    isDisabled={!hasLoaded}
                    placeholder=""
                    classNamePrefix="react-select"
                    onChange={handleOnSelectedProject}
                    menuPlacement="top"
                    options={optionsWithCreate}
                    formatOptionLabel={formatLabel}
                    value={selectedOption}
                    styles={{
                        menu: (base) => ({
                            ...base,
                            width: "max-content",
                            minWidth: "100%",
                        }),
                    }}
                />
            </div>

            {/* <div className="status-bar-message">{activeNotifications[0]?.message}</div> */}

            <div className="status-bar-tray">
                <TaskArea key={activeProjectId} />
                <button className="button-with-icon" onClick={handleOnClickNotifications}>
                    <FontAwesomeIcon icon={faBell} />
                </button>
            </div>

            <AddProjectModal isVisible={isAddProjectModalVisible} setIsVisible={setIsAddProjectModalVisible} />
        </footer>
    );
}

export default StatusBar;
